const DATE_PRESETS = new Set([
  "all",
  "today",
  "last7",
  "last30",
  "last90",
  "custom"
]);

const formatCalendarDate = (date) => {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const cairoCalendarDate = (date) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Africa/Cairo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export const resolveOperationDateRange = (filters = {}, now = new Date()) => {
  const preset = DATE_PRESETS.has(filters.datePreset)
    ? filters.datePreset
    : filters.dateFrom || filters.dateTo
      ? "custom"
      : "all";
  if (preset === "custom") {
    return {
      dateFrom: filters.dateFrom || "",
      dateTo: filters.dateTo || ""
    };
  }
  const days = {
    today: 1,
    last7: 7,
    last30: 30,
    last90: 90
  }[preset];
  if (!days) return { dateFrom: "", dateTo: "" };
  const dateTo = cairoCalendarDate(now);
  const [year, month, day] = dateTo.split("-").map(Number);
  const start = new Date(Date.UTC(year, month - 1, day - (days - 1)));
  return { dateFrom: formatCalendarDate(start), dateTo };
};

export const buildOperationListQuery = ({ filters = {}, page, perPage } = {}, now) => {
  const range = resolveOperationDateRange(filters, now);
  const params = new URLSearchParams();
  Object.entries({ page, perPage, ...filters, ...range }).forEach(([key, value]) => {
    if (key === "datePreset") return;
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      params.set(key, String(value).trim());
    }
  });
  return params.toString();
};

export const hasActiveOperationFilters = (filters = {}, searchDraft = "") => Boolean(
  String(searchDraft || filters.search || "").trim() ||
  String(filters.operationReference || "").trim() ||
  filters.operationStatus ||
  filters.contractReviewStatus ||
  filters.platformFeeStatus ||
  (filters.datePreset && filters.datePreset !== "all")
);

export { DATE_PRESETS };
